import template from './sw-first-run-wizard-paypal-base.html.twig';

/**
 * @package services-settings
 */
// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    template,
};
